export enum ConfirmationDialogTestIds {
    DialogRootElement = 'confirmation-dialog-root-element',
    DialogContentElement = 'confirmation-dialog-content-element',
    CancelButton = 'confirmation-dialog-cancel-button',
    ConfirmationButton = 'confirmation-dialog-confirm-button'
}